import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/chevron-left/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/chevron-left/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/chevron-left/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconChevronLeft24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Leftward arrow`, id: 'icon.title.chevron-left', comment: 'Title for chevron-left icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-chevron-left-24-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15.75 20.625-8.25-8.25 8.25-8.25"></path></svg>`; }
}
if (!customElements.get('w-icon-chevron-left-24')) {
  customElements.define('w-icon-chevron-left-24', IconChevronLeft24);
}